import React from 'react';
import { useRecipientFilter } from '../../../../../../../contexts/RecipientFilter';
import "./RecipientFilterContainer.scss";
import CriteriaContainer from './RFCriteriaContainer';

export const QA_ID_PREFIX = "RecipientFilterContainer";

function RecipientFilterContainer() {

    const {
        rawFilter,
        filterId
    } = useRecipientFilter();

    return (
        <div
            className='recipient-filter-container'
            data-testid={`${QA_ID_PREFIX}-container`}
        >
            <h2 data-testid={`${QA_ID_PREFIX}-title`}>
                { filterId ? "Edit Filters" : "Recipient Filtering" }
            </h2>
            <p data-testid={`${QA_ID_PREFIX}-description`}>
                Build a list based on specific attributes. Use SSOT data to create recipient list based on configurable filters.
            </p>

            <div data-testid={`${QA_ID_PREFIX}-criteria-container`}>
                <CriteriaContainer/>
            </div>
        </div>
    )
}

export default RecipientFilterContainer;